import type { FC } from 'react';
import { ReceiptStatusValues } from '@pflegenavi/shared/api';
import type { ReceiptState } from '@pflegenavi/shared/api';
import { Label } from './Label';
import { useTranslation } from 'react-i18next';

export const ReceiptStatusLabel: FC<{
  status: ReceiptStatusValues | ReceiptState | 'Cancelled' | 'Created' | 'Done';
}> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <Label
      variant="ghost"
      color={
        (status === ReceiptStatusValues.SUBMITTED && 'success') ||
        (status === ReceiptStatusValues.AWAITING_SETTLEMENT && 'info') ||
        (status === ReceiptStatusValues.SETTLED && 'success') ||
        (status === 'Created' && 'info') ||
        (status === 'Done' && 'success') ||
        (status === ReceiptStatusValues.DRAFT && 'default') ||
        (status === ReceiptStatusValues.PENDING && 'warning') ||
        ((status === ReceiptStatusValues.INCOMPLETE ||
          status === 'Cancelled') &&
          'error') ||
        'default'
      }
    >
      {t(`receipts.status.${status}`)}
    </Label>
  );
};
